import "sanity/bundle.css";
import { A as MenuItemBuilder, C as FormViewBuilder, D as ComponentBuilder, E as maybeSerializeView, F as SerializeError, I as structureLocaleNamespace, M as getOrderingMenuItemsForSchemaType, N as maybeSerializeMenuItem, O as MenuItemGroupBuilder, P as HELP_URL, S as form, T as GenericViewBuilder, _ as menuItemsFromInitialValueTemplateItems, a as DocumentListItemBuilder, b as documentFromEditorWithInitialValue, c as DocumentListBuilder, d as DEFAULT_INTENT_HANDLER, f as defaultIntentChecker, g as maybeSerializeInitialValueTemplateItem, h as defaultInitialValueTemplateItems, i as DocumentTypeListBuilder, j as getOrderingMenuItem, k as maybeSerializeMenuItemGroup, l as GenericListBuilder, m as InitialValueTemplateItemBuilder, n as createStructureBuilder, o as isDocumentListItem, p as getTypeNamesFromFilter, r as ListBuilder, s as ListItemBuilder, t as StructureToolProvider, u as shallowIntentChecker, v as DocumentBuilder, w as ComponentViewBuilder, x as component, y as documentFromEditor } from "./StructureToolProvider-iNNgQWHT.js";
import { i as MenuButton$1, o as Button$1, r as MenuItem$1 } from "./Tab-BnUC9P6t.js";
import { C as PaneRouterContext, E as useDocumentPane, S as ConfirmDeleteDialogContainer, T as useDocumentTitle, a as getCrossDatasetIncomingReferences, b as DocumentInspectorHeader, f as DocumentPane, g as ActionStateDialog, i as getIncomingReferences, m as usePaneOptions, n as IncomingReferencePreview, o as CrossDatasetIncomingReferenceDocumentPreview, p as DocumentPaneProviderWrapper, r as IncomingReferencesListContainer, t as structureTool, w as usePaneRouter, x as PaneLayout } from "./structureTool-623Gqd78.js";
import { i as Pane, t as useStructureTool } from "./useStructureTool-G_BLSbNQ.js";
import { i as PaneContent } from "./constants-CYqMRcAg.js";
import { n as ORDER_BY_IDS_PARAM_FIELD, t as PaneContainer } from "./PaneContainer-D8aV3mMP.js";
import { Suspense, use, useEffect, useState } from "react";
import { map } from "rxjs";
import { c } from "react/compiler-runtime";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { Card, Text } from "@sanity/ui";
import { Box as Box$1, Flex, Grid, VStack } from "ui5";
import { useToast } from "@sanity/ui/toast";
import { useObservable, useObservablePromise } from "react-rx";
import { motion } from "motion/react";
import { uuid } from "@sanity/uuid";
import { useRouter } from "sanity/router";
import { DEFAULT_MAX_FIELD_DEPTH } from "@sanity/schema/_internal";
import { Menu } from "@sanity/ui/menu";
import { AddIcon } from "@sanity/icons/Add";
import startCase from "lodash-es/startCase.js";
import { CommandList, ContextMenuButton, CreateReferenceButton, DEFAULT_STUDIO_CLIENT_OPTIONS, GetHookCollectionState, LegacyLayerProvider, LoadingBlock, PreviewCard, ReferenceAutocomplete, ReleaseTitle, SanityDefaultPreview, VersionInlineBadge, createSearch, getDraftId, getPreviewStateObservable, getPreviewValueWithFallback, getPublishedId, getReferencePaths, getReleaseIdFromReleaseDocumentId, getReleaseTone, getVersionFromId, isDraftId, isNonNullable, isPublishedId, isVersionId, useActiveReleases, useClient, useDocumentPreviewStore, useReferenceInputOptions, useSchema, useSearchMachine, useSource, useTranslation } from "sanity";
function CrossDatasetIncomingReferenceType(t0) {
	let $ = c(20), { type, referenced, shouldRenderTitle } = t0, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), documentPreviewStore = useDocumentPreviewStore(), t1;
	$[0] !== client || $[1] !== documentPreviewStore || $[2] !== referenced.id || $[3] !== type ? (t1 = getCrossDatasetIncomingReferences({
		documentId: referenced.id,
		client,
		type,
		documentPreviewStore
	}), $[0] = client, $[1] = documentPreviewStore, $[2] = referenced.id, $[3] = type, $[4] = t1) : t1 = $[4];
	let referencesPromise = useObservablePromise(t1), schema = useSchema(), { t } = useTranslation(structureLocaleNamespace), t2;
	$[5] !== schema || $[6] !== type.type ? (t2 = schema.get(type.type), $[5] = schema, $[6] = type.type, $[7] = t2) : t2 = $[7];
	let schemaType = t2;
	if (!schemaType) return null;
	let t3;
	$[8] === t ? t3 = $[9] : (t3 = t("incoming-references-input.types-loading-cross-dataset"), $[8] = t, $[9] = t3);
	let t4;
	$[10] === t3 ? t4 = $[11] : (t4 = /* @__PURE__ */ jsx(LoadingBlock, {
		showText: !0,
		title: t3
	}), $[10] = t3, $[11] = t4);
	let t5;
	$[12] !== referencesPromise || $[13] !== schemaType || $[14] !== shouldRenderTitle || $[15] !== type ? (t5 = /* @__PURE__ */ jsx(CrossDatasetIncomingReferenceTypeList, {
		referencesPromise,
		schemaType,
		shouldRenderTitle,
		type
	}), $[12] = referencesPromise, $[13] = schemaType, $[14] = shouldRenderTitle, $[15] = type, $[16] = t5) : t5 = $[16];
	let t6;
	return $[17] !== t4 || $[18] !== t5 ? (t6 = /* @__PURE__ */ jsx(Suspense, {
		fallback: t4,
		children: t5
	}), $[17] = t4, $[18] = t5, $[19] = t6) : t6 = $[19], t6;
}
function CrossDatasetIncomingReferenceTypeList(t0) {
	let $ = c(15), { type, shouldRenderTitle, referencesPromise, schemaType } = t0, documents = use(referencesPromise), { t } = useTranslation(structureLocaleNamespace), t1;
	$[0] === type ? t1 = $[1] : (t1 = (document) => /* @__PURE__ */ jsx(CrossDatasetIncomingReferenceDocumentPreview, {
		document,
		type
	}), $[0] = type, $[1] = t1);
	let renderItem = t1, t2;
	$[2] !== schemaType?.title || $[3] !== shouldRenderTitle || $[4] !== type ? (t2 = shouldRenderTitle && /* @__PURE__ */ jsx(Box$1, {
		paddingY: 2,
		paddingX: 0,
		children: /* @__PURE__ */ jsx(Text, {
			size: 1,
			weight: "medium",
			children: type.title || schemaType?.title
		})
	}), $[2] = schemaType?.title, $[3] = shouldRenderTitle, $[4] = type, $[5] = t2) : t2 = $[5];
	let t3;
	$[6] !== documents || $[7] !== renderItem || $[8] !== schemaType?.title || $[9] !== t || $[10] !== type ? (t3 = /* @__PURE__ */ jsx(Card, {
		radius: 2,
		padding: 1,
		border: !0,
		tone: "default",
		children: documents && documents.length > 0 ? /* @__PURE__ */ jsx(IncomingReferencesListContainer, {
			$itemCount: documents.length,
			children: /* @__PURE__ */ jsx(CommandList, {
				activeItemDataAttr: "data-hovered",
				ariaLabel: t("incoming-references-input.list-label", { type: type.title || schemaType?.title }),
				canReceiveFocus: !0,
				fixedHeight: !0,
				getItemKey: (index) => documents[index].id,
				itemHeight: 51,
				items: documents,
				onlyShowSelectionWhenActive: !0,
				overscan: 5,
				renderItem,
				wrapAround: !1
			})
		}) : /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(Flex, {
			alignItems: "center",
			justifyContent: "center",
			padding: 2,
			children: /* @__PURE__ */ jsx(Text, {
				size: 1,
				muted: !0,
				children: t("incoming-references-input.no-items")
			})
		}) })
	}), $[6] = documents, $[7] = renderItem, $[8] = schemaType?.title, $[9] = t, $[10] = type, $[11] = t3) : t3 = $[11];
	let t4;
	return $[12] !== t2 || $[13] !== t3 ? (t4 = /* @__PURE__ */ jsxs(Flex, {
		gap: 2,
		marginBottom: 2,
		flexDirection: "column",
		children: [t2, t3]
	}), $[12] = t2, $[13] = t3, $[14] = t4) : t4 = $[14], t4;
}
function CreateNewIncomingReference(t0) {
	let $ = c(23), { type, referenceToId, referenceToType, onCreateNewReference, fieldName, creationAllowed } = t0, { initialValueTemplateItems } = useReferenceInputOptions(), { navigate } = useRouter(), { routerPanesState, groupIndex } = usePaneRouter(), t1;
	$[0] !== fieldName || $[1] !== groupIndex || $[2] !== navigate || $[3] !== onCreateNewReference || $[4] !== referenceToId || $[5] !== referenceToType || $[6] !== routerPanesState || $[7] !== type ? (t1 = (option) => {
		let id = uuid();
		navigate({ panes: [...routerPanesState.slice(0, groupIndex + 1), [{
			id: getPublishedId(id),
			params: {
				type,
				template: option.template.id
			},
			payload: {
				reference: {
					_type: "reference",
					_ref: referenceToId,
					_weak: !0,
					_strengthenOnPublish: { type: referenceToType }
				},
				from: {
					fieldName,
					type: referenceToType
				},
				__internal_isIncomingReferenceCreation: !0
			}
		}]] }), onCreateNewReference(id);
	}, $[0] = fieldName, $[1] = groupIndex, $[2] = navigate, $[3] = onCreateNewReference, $[4] = referenceToId, $[5] = referenceToType, $[6] = routerPanesState, $[7] = type, $[8] = t1) : t1 = $[8];
	let handleCreate = t1, t2;
	bb0: {
		if (!creationAllowed) {
			let t3;
			$[9] === Symbol.for("react.memo_cache_sentinel") ? (t3 = [], $[9] = t3) : t3 = $[9], t2 = t3;
			break bb0;
		}
		let t3;
		$[10] === initialValueTemplateItems ? t3 = $[11] : (t3 = initialValueTemplateItems || [], $[10] = initialValueTemplateItems, $[11] = t3);
		let t4;
		if ($[12] !== creationAllowed || $[13] !== t3 || $[14] !== type) {
			let t5;
			$[16] !== creationAllowed || $[17] !== type ? (t5 = (i) => {
				let typeMatch = type === i.template?.schemaType;
				return Array.isArray(creationAllowed) ? typeMatch && creationAllowed.includes(i.template.id) : typeMatch;
			}, $[16] = creationAllowed, $[17] = type, $[18] = t5) : t5 = $[18], t4 = t3.filter(t5).map(_temp$2).filter(isNonNullable), $[12] = creationAllowed, $[13] = t3, $[14] = type, $[15] = t4;
		} else t4 = $[15];
		t2 = t4;
	}
	let createOptions = t2;
	if (!creationAllowed) return null;
	let t3 = `create-new-incoming-reference-${type}`, t4;
	return $[19] !== createOptions || $[20] !== handleCreate || $[21] !== t3 ? (t4 = /* @__PURE__ */ jsx(CreateReferenceButton, {
		id: t3,
		createOptions,
		onCreate: handleCreate
	}), $[19] = createOptions, $[20] = handleCreate, $[21] = t3, $[22] = t4) : t4 = $[22], t4;
}
function _temp$2(item) {
	return item.template?.schemaType ? {
		id: item.id,
		title: item.title || `${item.template.schemaType} from template ${item.template?.id}`,
		i18n: item.i18n,
		type: item.template.schemaType,
		icon: item.icon,
		template: {
			id: item.template?.id,
			params: item.parameters
		},
		permission: {
			granted: item.granted,
			reason: item.reason
		}
	} : void 0;
}
const getPerspective = (id) => isDraftId(id) ? ["drafts"] : isVersionId(id) ? [getVersionFromId(id)] : isPublishedId(id) ? ["published"] : ["raw"], INITIAL_PREVIEW_STATE = {
	snapshot: null,
	isLoading: !0,
	original: null
};
function LinkToExistingPreview(props) {
	let $ = c(36), { schemaType, value, onLinkToDocument } = props, { data: releases } = useActiveReleases(), { t } = useTranslation(), t0;
	$[0] !== props.documentPreviewStore || $[1] !== schemaType || $[2] !== value._id ? (t0 = getPreviewStateObservable(props.documentPreviewStore, schemaType, value._id, getPerspective(value._id)), $[0] = props.documentPreviewStore, $[1] = schemaType, $[2] = value._id, $[3] = t0) : t0 = $[3];
	let { snapshot, original, isLoading } = useObservable(t0, INITIAL_PREVIEW_STATE), t1;
	if ($[4] !== releases || $[5] !== t || $[6] !== value._id) {
		bb0: {
			let id = value._id;
			if (isDraftId(id)) {
				let t2;
				$[8] === Symbol.for("react.memo_cache_sentinel") ? (t2 = getReleaseTone("drafts"), $[8] = t2) : t2 = $[8];
				let t3;
				$[9] === t ? t3 = $[10] : (t3 = t("release.chip.draft"), $[9] = t, $[10] = t3);
				let t4;
				$[11] === t3 ? t4 = $[12] : (t4 = {
					kind: "static",
					tone: t2,
					text: t3
				}, $[11] = t3, $[12] = t4), t1 = t4;
				break bb0;
			}
			if (isPublishedId(id)) {
				let t2;
				$[13] === Symbol.for("react.memo_cache_sentinel") ? (t2 = getReleaseTone("published"), $[13] = t2) : t2 = $[13];
				let t3;
				$[14] === t ? t3 = $[15] : (t3 = t("release.chip.published"), $[14] = t, $[15] = t3);
				let t4;
				$[16] === t3 ? t4 = $[17] : (t4 = {
					kind: "static",
					tone: t2,
					text: t3
				}, $[16] = t3, $[17] = t4), t1 = t4;
				break bb0;
			}
			if (isVersionId(id)) {
				let t2;
				$[18] === id ? t2 = $[19] : (t2 = getVersionFromId(id), $[18] = id, $[19] = t2);
				let releaseId = t2, t3;
				$[20] === releaseId ? t3 = $[21] : (t3 = (r) => getReleaseIdFromReleaseDocumentId(r._id) === releaseId, $[20] = releaseId, $[21] = t3);
				let release = releases.find(t3);
				if (release) {
					t1 = {
						kind: "release",
						tone: getReleaseTone(release),
						releaseTitle: release.metadata.title,
						releaseFallback: release._id
					};
					break bb0;
				}
			}
			t1 = null;
		}
		$[4] = releases, $[5] = t, $[6] = value._id, $[7] = t1;
	} else t1 = $[7];
	let badgeProps = t1;
	if (!snapshot && !isLoading) return null;
	let t2;
	$[22] !== original || $[23] !== snapshot || $[24] !== value ? (t2 = getPreviewValueWithFallback({
		snapshot,
		original,
		fallback: value
	}), $[22] = original, $[23] = snapshot, $[24] = value, $[25] = t2) : t2 = $[25];
	let t3;
	$[26] === badgeProps ? t3 = $[27] : (t3 = badgeProps ? /* @__PURE__ */ jsx(Text, {
		size: 0,
		children: badgeProps.kind === "release" ? /* @__PURE__ */ jsx(ReleaseTitle, {
			title: badgeProps.releaseTitle,
			fallback: badgeProps.releaseFallback,
			children: (t4) => {
				let { displayTitle } = t4;
				return /* @__PURE__ */ jsx(VersionInlineBadge, {
					$tone: badgeProps.tone,
					children: displayTitle
				});
			}
		}) : /* @__PURE__ */ jsx(VersionInlineBadge, {
			$tone: badgeProps.tone,
			children: badgeProps.text
		})
	}) : void 0, $[26] = badgeProps, $[27] = t3);
	let t4;
	$[28] !== isLoading || $[29] !== schemaType.icon || $[30] !== t2 || $[31] !== t3 ? (t4 = /* @__PURE__ */ jsx(SanityDefaultPreview, {
		...t2,
		isPlaceholder: isLoading,
		icon: schemaType.icon,
		layout: "default",
		status: t3
	}), $[28] = isLoading, $[29] = schemaType.icon, $[30] = t2, $[31] = t3, $[32] = t4) : t4 = $[32];
	let t5;
	return $[33] !== onLinkToDocument || $[34] !== t4 ? (t5 = /* @__PURE__ */ jsx(PreviewCard, {
		__unstable_focusRing: !0,
		onClick: onLinkToDocument,
		as: "button",
		radius: 2,
		children: t4
	}), $[33] = onLinkToDocument, $[34] = t4, $[35] = t5) : t5 = $[35], t5;
}
const NO_FILTER = () => !0, incomingReferenceSearch = (client, schemaType, searchStrategy) => {
	let search = createSearch([schemaType], client, {
		maxDepth: DEFAULT_MAX_FIELD_DEPTH,
		strategy: searchStrategy,
		tag: "search.incoming-reference"
	});
	return (textTerm) => search(textTerm, { perspective: "raw" }).pipe(map(({ hits }) => hits.map(({ hit }) => hit)), map((docs) => {
		let byId = /* @__PURE__ */ new Map();
		return docs.forEach((doc) => {
			if (isVersionId(doc._id)) {
				byId.set(doc._id, doc);
				return;
			}
			let publishedId = getPublishedId(doc._id), entry = byId.get(publishedId);
			entry ? isDraftId(doc._id) && isPublishedId(entry._id) && byId.set(publishedId, doc) : byId.set(publishedId, doc);
		}), Array.from(byId.values());
	}), map((collated) => collated.map((entry) => ({
		_id: entry._id,
		_type: entry._type
	}))), map((docs) => docs.slice(0, 100)));
};
/**
* This component is responsible for two things:
* 1) Search for the document type to add to the incoming references.
* 2) Render the CreateNewIncomingReference button. Allowing users to add a new incoming reference.
*/
function AddIncomingReference(t0) {
	let $ = c(54), { type, referenced, onCreateNewReference, onLinkDocument, fieldName, creationAllowed } = t0, { t } = useTranslation(structureLocaleNamespace), { push } = useToast(), schema = useSchema(), t1;
	$[0] !== schema || $[1] !== type ? (t1 = schema.get(type), $[0] = schema, $[1] = type, $[2] = t1) : t1 = $[2];
	let schemaType = t1, client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), { strategy: searchStrategy } = useSource().search, documentPreviewStore = useDocumentPreviewStore(), t2;
	$[3] !== client || $[4] !== schemaType || $[5] !== searchStrategy ? (t2 = incomingReferenceSearch(client, schemaType, searchStrategy), $[3] = client, $[4] = schemaType, $[5] = searchStrategy, $[6] = t2) : t2 = $[6];
	let handleSearch = t2, t3;
	$[7] !== push || $[8] !== type ? (t3 = (error) => {
		push({
			title: "Reference search failed",
			description: error.message,
			status: "error",
			id: `reference-search-fail-${type}`
		}), console.error(error);
	}, $[7] = push, $[8] = type, $[9] = t3) : t3 = $[9];
	let t4;
	$[10] !== handleSearch || $[11] !== t3 ? (t4 = {
		search: handleSearch,
		onSearchFailed: t3
	}, $[10] = handleSearch, $[11] = t3, $[12] = t4) : t4 = $[12];
	let { searchState, handleQueryChange } = useSearchMachine(t4), t5;
	$[13] === searchState.hits ? t5 = $[14] : (t5 = searchState.hits.map(_temp$1), $[13] = searchState.hits, $[14] = t5);
	let options = t5, t6;
	$[15] === handleQueryChange ? t6 = $[16] : (t6 = () => {
		handleQueryChange("");
	}, $[15] = handleQueryChange, $[16] = t6);
	let handleAutocompleteOpenButtonClick = t6, t7;
	$[17] !== documentPreviewStore || $[18] !== onLinkDocument || $[19] !== schemaType ? (t7 = (option) => /* @__PURE__ */ jsx(LinkToExistingPreview, {
		onLinkToDocument: () => onLinkDocument(option.value),
		documentPreviewStore,
		schemaType,
		value: option.hit
	}), $[17] = documentPreviewStore, $[18] = onLinkDocument, $[19] = schemaType, $[20] = t7) : t7 = $[20];
	let renderOption = t7, t8;
	$[21] !== t || $[22] !== type ? (t8 = t("incoming-references-input.reference-from", { type }), $[21] = t, $[22] = type, $[23] = t8) : t8 = $[23];
	let t9;
	$[24] === t8 ? t9 = $[25] : (t9 = /* @__PURE__ */ jsx(Box$1, {
		paddingY: 2,
		children: /* @__PURE__ */ jsx(Text, {
			size: 1,
			weight: "medium",
			children: t8
		})
	}), $[24] = t8, $[25] = t9);
	let t10 = creationAllowed ? 2 : 0, t11;
	$[26] === Symbol.for("react.memo_cache_sentinel") ? (t11 = { gridTemplateColumns: "1fr min-content" }, $[26] = t11) : t11 = $[26];
	let t12 = `${type}-autocomplete`, t13;
	$[27] === t ? t13 = $[28] : (t13 = t("incoming-references-input.type-to-search"), $[27] = t, $[28] = t13);
	let t14;
	$[29] === Symbol.for("react.memo_cache_sentinel") ? (t14 = [], $[29] = t14) : t14 = $[29];
	let t15;
	$[30] === handleAutocompleteOpenButtonClick ? t15 = $[31] : (t15 = { onClick: handleAutocompleteOpenButtonClick }, $[30] = handleAutocompleteOpenButtonClick, $[31] = t15);
	let t16;
	$[32] !== handleQueryChange || $[33] !== options || $[34] !== renderOption || $[35] !== searchState.isLoading || $[36] !== t12 || $[37] !== t13 || $[38] !== t15 ? (t16 = /* @__PURE__ */ jsx(ReferenceAutocomplete, {
		id: t12,
		radius: 2,
		autoFocus: !0,
		options,
		placeholder: t13,
		onQueryChange: handleQueryChange,
		filterOption: NO_FILTER,
		path: t14,
		renderOption,
		openButton: t15,
		referenceElement: null,
		loading: searchState.isLoading
	}), $[32] = handleQueryChange, $[33] = options, $[34] = renderOption, $[35] = searchState.isLoading, $[36] = t12, $[37] = t13, $[38] = t15, $[39] = t16) : t16 = $[39];
	let t17;
	$[40] !== creationAllowed || $[41] !== fieldName || $[42] !== onCreateNewReference || $[43] !== referenced.id || $[44] !== referenced.type || $[45] !== type ? (t17 = /* @__PURE__ */ jsx(CreateNewIncomingReference, {
		type,
		referenceToId: referenced.id,
		referenceToType: referenced.type,
		creationAllowed,
		onCreateNewReference,
		fieldName
	}), $[40] = creationAllowed, $[41] = fieldName, $[42] = onCreateNewReference, $[43] = referenced.id, $[44] = referenced.type, $[45] = type, $[46] = t17) : t17 = $[46];
	let t18;
	$[47] !== t10 || $[48] !== t16 || $[49] !== t17 ? (t18 = /* @__PURE__ */ jsxs(Grid, {
		gap: t10,
		style: t11,
		children: [t16, t17]
	}), $[47] = t10, $[48] = t16, $[49] = t17, $[50] = t18) : t18 = $[50];
	let t19;
	return $[51] !== t18 || $[52] !== t9 ? (t19 = /* @__PURE__ */ jsxs(Flex, {
		gap: 2,
		padding: 2,
		flexDirection: "column",
		children: [t9, t18]
	}), $[51] = t18, $[52] = t9, $[53] = t19) : t19 = $[53], t19;
}
function _temp$1(hit) {
	return {
		value: hit._id,
		hit
	};
}
const IncomingReferenceDocumentActionsInner = (t0) => {
	let $ = c(20), { states, document, setIsExecutingAction, isExecutingAction } = t0, [actionIndex, setActionIndex] = useState(-1), [referenceElement, setReferenceElement] = useState(null), currentAction = states[actionIndex];
	if (!states.length) return null;
	let t1;
	$[0] === isExecutingAction ? t1 = $[1] : (t1 = /* @__PURE__ */ jsx(ContextMenuButton, { loading: isExecutingAction }), $[0] = isExecutingAction, $[1] = t1);
	let t2 = `${document._id}-menuButton`, t3;
	if ($[2] !== setIsExecutingAction || $[3] !== states) {
		let t4;
		$[5] === setIsExecutingAction ? t4 = $[6] : (t4 = (action, index) => /* @__PURE__ */ jsx(MenuItem$1, {
			text: action.label,
			icon: action.icon,
			tone: action.tone,
			disabled: !!action.disabled,
			onClick: async () => {
				setActionIndex(index), setIsExecutingAction(!0), await action.onHandle?.(), setIsExecutingAction(!1);
			}
		}, action.label), $[5] = setIsExecutingAction, $[6] = t4), t3 = states.map(t4), $[2] = setIsExecutingAction, $[3] = states, $[4] = t3;
	} else t3 = $[4];
	let t4;
	$[7] === t3 ? t4 = $[8] : (t4 = /* @__PURE__ */ jsx(Menu, { children: t3 }), $[7] = t3, $[8] = t4);
	let t5;
	$[9] === Symbol.for("react.memo_cache_sentinel") ? (t5 = {
		portal: !0,
		tone: "default"
	}, $[9] = t5) : t5 = $[9];
	let t6;
	$[10] !== t1 || $[11] !== t2 || $[12] !== t4 ? (t6 = /* @__PURE__ */ jsx(Box$1, {
		ref: setReferenceElement,
		children: /* @__PURE__ */ jsx(MenuButton$1, {
			button: t1,
			id: t2,
			menu: t4,
			popover: t5
		})
	}), $[10] = t1, $[11] = t2, $[12] = t4, $[13] = t6) : t6 = $[13];
	let t7;
	$[14] !== currentAction || $[15] !== referenceElement ? (t7 = currentAction && currentAction.dialog && /* @__PURE__ */ jsx(LegacyLayerProvider, {
		zOffset: "pane",
		children: /* @__PURE__ */ jsx(ActionStateDialog, {
			dialog: currentAction.dialog,
			referenceElement
		})
	}), $[14] = currentAction, $[15] = referenceElement, $[16] = t7) : t7 = $[16];
	let t8;
	return $[17] !== t6 || $[18] !== t7 ? (t8 = /* @__PURE__ */ jsxs(Fragment$1, { children: [t6, t7] }), $[17] = t6, $[18] = t7, $[19] = t8) : t8 = $[19], t8;
}, IncomingReferenceDocumentActions = (props) => {
	let $ = c(11), { document, actions, setIsExecutingAction, isExecutingAction } = props, { getClient } = useSource(), t0;
	$[0] !== document || $[1] !== isExecutingAction || $[2] !== setIsExecutingAction ? (t0 = (t1) => {
		let { states } = t1;
		return /* @__PURE__ */ jsx(IncomingReferenceDocumentActionsInner, {
			states,
			document,
			setIsExecutingAction,
			isExecutingAction
		}, document._id);
	}, $[0] = document, $[1] = isExecutingAction, $[2] = setIsExecutingAction, $[3] = t0) : t0 = $[3];
	let renderActions = t0, t1;
	$[4] !== document || $[5] !== getClient ? (t1 = {
		document,
		getClient
	}, $[4] = document, $[5] = getClient, $[6] = t1) : t1 = $[6];
	let t2;
	return $[7] !== actions || $[8] !== renderActions || $[9] !== t1 ? (t2 = /* @__PURE__ */ jsx(GetHookCollectionState, {
		hooks: actions,
		args: t1,
		children: renderActions
	}), $[7] = actions, $[8] = renderActions, $[9] = t1, $[10] = t2) : t2 = $[10], t2;
}, Root = motion.create(Flex), variants = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	actionInProgress: {
		opacity: [
			.5,
			1,
			.5
		],
		transition: {
			duration: 1.8,
			repeat: Infinity,
			ease: "easeInOut"
		}
	}
}, ErrorCard = (t0) => {
	let $ = c(2), { message } = t0, t1;
	return $[0] === message ? t1 = $[1] : (t1 = /* @__PURE__ */ jsx(Card, {
		border: !0,
		radius: 2,
		padding: 1,
		tone: "critical",
		children: /* @__PURE__ */ jsx(Box$1, {
			paddingY: 4,
			paddingX: 3,
			children: /* @__PURE__ */ jsx(Text, {
				size: 1,
				children: message
			})
		})
	}), $[0] = message, $[1] = t1), t1;
}, IncomingReferenceDocument = (props) => {
	let $ = c(24), { document, referenceToId, actions } = props, t0;
	$[0] !== document || $[1] !== referenceToId ? (t0 = getReferencePaths(document, referenceToId), $[0] = document, $[1] = referenceToId, $[2] = t0) : t0 = $[2];
	let referencePaths = t0, [isExecutingAction, setIsExecutingAction] = useState(!1), schema = useSchema(), type = document?._type, { t } = useTranslation(structureLocaleNamespace), t1;
	$[3] !== schema || $[4] !== type ? (t1 = schema.get(type), $[3] = schema, $[4] = type, $[5] = t1) : t1 = $[5];
	let schemaType = t1;
	if (!schemaType) {
		let t2;
		$[6] !== t || $[7] !== type ? (t2 = t("incoming-references-input.schema-type-not-found", { type }), $[6] = t, $[7] = type, $[8] = t2) : t2 = $[8];
		let t3;
		return $[9] === t2 ? t3 = $[10] : (t3 = /* @__PURE__ */ jsx(ErrorCard, { message: t2 }), $[9] = t2, $[10] = t3), t3;
	}
	let t2 = isExecutingAction ? "actionInProgress" : "animate", t3;
	$[11] !== document || $[12] !== referencePaths[0] || $[13] !== referencePaths.length || $[14] !== schemaType ? (t3 = /* @__PURE__ */ jsx(Box$1, {
		flexBasis: "0%",
		flexGrow: 1,
		children: referencePaths.length > 0 ? /* @__PURE__ */ jsx(IncomingReferencePreview, {
			type: schemaType,
			value: document,
			path: referencePaths[0]
		}) : /* @__PURE__ */ jsx(SanityDefaultPreview, {
			icon: schemaType.icon,
			layout: "default",
			isPlaceholder: !0
		})
	}), $[11] = document, $[12] = referencePaths[0], $[13] = referencePaths.length, $[14] = schemaType, $[15] = t3) : t3 = $[15];
	let t4;
	$[16] !== actions || $[17] !== document || $[18] !== isExecutingAction ? (t4 = actions && actions?.length > 0 && /* @__PURE__ */ jsx(IncomingReferenceDocumentActions, {
		document,
		actions,
		isExecutingAction,
		setIsExecutingAction
	}), $[16] = actions, $[17] = document, $[18] = isExecutingAction, $[19] = t4) : t4 = $[19];
	let t5;
	return $[20] !== t2 || $[21] !== t3 || $[22] !== t4 ? (t5 = /* @__PURE__ */ jsxs(Root, {
		initial: "initial",
		animate: t2,
		gap: 1,
		alignItems: "center",
		variants,
		children: [t3, t4]
	}), $[20] = t2, $[21] = t3, $[22] = t4, $[23] = t5) : t5 = $[23], t5;
};
function IncomingReferencesType(t0) {
	let $ = c(31), { type, referenced, onLinkDocument, actions, shouldRenderTitle, fieldName, creationAllowed, filter, filterParams } = t0, documentPreviewStore = useDocumentPreviewStore(), { displayed } = useDocumentPane(), { getClient } = useSource(), displayedId = displayed?._id, t1;
	$[0] === filter ? t1 = $[1] : (t1 = () => filter, $[0] = filter, $[1] = t1);
	let [memoizedFilter] = useState(t1), t2;
	$[2] === filterParams ? t2 = $[3] : (t2 = () => filterParams, $[2] = filterParams, $[3] = t2);
	let [memoizedFilterParams] = useState(t2), t3;
	$[4] !== displayedId || $[5] !== documentPreviewStore || $[6] !== getClient || $[7] !== memoizedFilter || $[8] !== memoizedFilterParams || $[9] !== type.type ? (t3 = getIncomingReferences({
		documentId: displayedId,
		documentPreviewStore,
		type: type.type,
		filter: memoizedFilter,
		filterParams: memoizedFilterParams,
		getClient
	}), $[4] = displayedId, $[5] = documentPreviewStore, $[6] = getClient, $[7] = memoizedFilter, $[8] = memoizedFilterParams, $[9] = type.type, $[10] = t3) : t3 = $[10];
	let referencesPromise = useObservablePromise(t3), schema = useSchema(), { t } = useTranslation(structureLocaleNamespace), t4;
	$[11] !== schema || $[12] !== type.type ? (t4 = schema.get(type.type), $[11] = schema, $[12] = type.type, $[13] = t4) : t4 = $[13];
	let schemaType = t4;
	if (!schemaType) return null;
	let t5;
	$[14] === t ? t5 = $[15] : (t5 = t("incoming-references-input.types-loading"), $[14] = t, $[15] = t5);
	let t6;
	$[16] === t5 ? t6 = $[17] : (t6 = /* @__PURE__ */ jsx(LoadingBlock, {
		showText: !0,
		title: t5
	}), $[16] = t5, $[17] = t6);
	let t7;
	$[18] !== actions || $[19] !== creationAllowed || $[20] !== fieldName || $[21] !== onLinkDocument || $[22] !== referenced || $[23] !== referencesPromise || $[24] !== schemaType || $[25] !== shouldRenderTitle || $[26] !== type ? (t7 = /* @__PURE__ */ jsx(IncomingReferencesTypeList, {
		actions,
		creationAllowed,
		fieldName,
		onLinkDocument,
		referenced,
		referencesPromise,
		schemaType,
		shouldRenderTitle,
		type
	}), $[18] = actions, $[19] = creationAllowed, $[20] = fieldName, $[21] = onLinkDocument, $[22] = referenced, $[23] = referencesPromise, $[24] = schemaType, $[25] = shouldRenderTitle, $[26] = type, $[27] = t7) : t7 = $[27];
	let t8;
	return $[28] !== t6 || $[29] !== t7 ? (t8 = /* @__PURE__ */ jsx(Suspense, {
		fallback: t6,
		children: t7
	}), $[28] = t6, $[29] = t7, $[30] = t8) : t8 = $[30], t8;
}
function IncomingReferencesTypeList(t0) {
	let $ = c(55), { type, referenced, onLinkDocument, actions, shouldRenderTitle, fieldName, creationAllowed, referencesPromise, schemaType } = t0, documents = use(referencesPromise), { t } = useTranslation(structureLocaleNamespace), client = useClient(DEFAULT_STUDIO_CLIENT_OPTIONS), [isAdding, setIsAdding] = useState(!1), [newReferenceId, setNewReferenceId] = useState(null), { editState } = useDocumentPane(), toast = useToast(), t1;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => {
		setIsAdding(_temp);
	}, $[0] = t1) : t1 = $[0];
	let handleAdd = t1, publishedExists = !!editState?.published, t2;
	$[1] === Symbol.for("react.memo_cache_sentinel") ? (t2 = async (documentId) => {
		setIsAdding(!1), setNewReferenceId(documentId);
	}, $[1] = t2) : t2 = $[1];
	let handleCreateNewReference = t2, t3;
	$[2] !== client || $[3] !== onLinkDocument || $[4] !== publishedExists || $[5] !== referenced.id || $[6] !== referenced.type || $[7] !== schemaType || $[8] !== toast ? (t3 = async (documentId_0) => {
		setIsAdding(!1), setNewReferenceId(documentId_0);
		try {
			let liveEdit = !!schemaType?.liveEdit, document = await client.fetch("*[_id == $id][0]", { id: documentId_0 }), linkedDocument = onLinkDocument?.(document, {
				_type: "reference",
				_ref: getPublishedId(referenced.id),
				...publishedExists ? {} : {
					_weak: !0,
					_strengthenOnPublish: { type: referenced.type }
				}
			});
			linkedDocument ? (isPublishedId(documentId_0) && !liveEdit && (linkedDocument._id = getDraftId(documentId_0)), await client.createOrReplace(linkedDocument)) : toast.push({
				title: "Not possible to link to document",
				description: "The document you are trying to link cannot be linked to",
				status: "error"
			});
		} catch (t4) {
			let err = t4;
			console.error(err), toast.push({
				title: "Failed to link document",
				description: err instanceof Error ? err.message : void 0,
				status: "error"
			});
		}
		setNewReferenceId(null);
	}, $[2] = client, $[3] = onLinkDocument, $[4] = publishedExists, $[5] = referenced.id, $[6] = referenced.type, $[7] = schemaType, $[8] = toast, $[9] = t3) : t3 = $[9];
	let handleLinkDocument = t3, t4, t5;
	$[10] !== documents || $[11] !== newReferenceId ? (t4 = () => {
		documents.length > 0 && newReferenceId && documents.find((document_0) => getPublishedId(document_0._id) === getPublishedId(newReferenceId)) && setNewReferenceId(null);
	}, t5 = [documents, newReferenceId], $[10] = documents, $[11] = newReferenceId, $[12] = t4, $[13] = t5) : (t4 = $[12], t5 = $[13]), useEffect(t4, t5);
	let t6;
	$[14] !== actions || $[15] !== referenced.id ? (t6 = (document_1) => /* @__PURE__ */ jsx(IncomingReferenceDocument, {
		document: document_1,
		referenceToId: referenced.id,
		actions
	}), $[14] = actions, $[15] = referenced.id, $[16] = t6) : t6 = $[16];
	let renderItem = t6, t7;
	$[17] !== schemaType?.title || $[18] !== shouldRenderTitle || $[19] !== type ? (t7 = shouldRenderTitle && /* @__PURE__ */ jsx(Box$1, {
		paddingY: 2,
		paddingX: 0,
		children: /* @__PURE__ */ jsx(Text, {
			size: 1,
			weight: "medium",
			children: type.title || schemaType?.title
		})
	}), $[17] = schemaType?.title, $[18] = shouldRenderTitle, $[19] = type, $[20] = t7) : t7 = $[20];
	let t8;
	$[21] !== documents || $[22] !== isAdding || $[23] !== newReferenceId || $[24] !== renderItem || $[25] !== schemaType?.title || $[26] !== t || $[27] !== type ? (t8 = documents.length > 0 ? /* @__PURE__ */ jsx(IncomingReferencesListContainer, {
		$itemCount: documents.length,
		children: /* @__PURE__ */ jsx(CommandList, {
			activeItemDataAttr: "data-hovered",
			ariaLabel: t("incoming-references-input.list-label", { type: type.title || schemaType?.title }),
			canReceiveFocus: !0,
			fixedHeight: !0,
			getItemKey: (index) => documents[index]._id,
			itemHeight: 51,
			items: documents,
			onlyShowSelectionWhenActive: !0,
			overscan: 5,
			renderItem,
			wrapAround: !1
		})
	}) : /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(Flex, {
		alignItems: "center",
		justifyContent: "center",
		padding: 2,
		hidden: isAdding || !!newReferenceId,
		children: /* @__PURE__ */ jsx(Text, {
			size: 1,
			muted: !0,
			children: t("incoming-references-input.no-items")
		})
	}) }), $[21] = documents, $[22] = isAdding, $[23] = newReferenceId, $[24] = renderItem, $[25] = schemaType?.title, $[26] = t, $[27] = type, $[28] = t8) : t8 = $[28];
	let t9;
	$[29] !== newReferenceId || $[30] !== schemaType ? (t9 = newReferenceId && /* @__PURE__ */ jsx(SanityDefaultPreview, {
		icon: schemaType.icon,
		layout: "default",
		isPlaceholder: !0
	}), $[29] = newReferenceId, $[30] = schemaType, $[31] = t9) : t9 = $[31];
	let t10;
	$[32] !== creationAllowed || $[33] !== fieldName || $[34] !== handleLinkDocument || $[35] !== isAdding || $[36] !== referenced || $[37] !== type ? (t10 = isAdding && /* @__PURE__ */ jsx(AddIncomingReference, {
		type: type.type,
		referenced,
		onCreateNewReference: handleCreateNewReference,
		onLinkDocument: handleLinkDocument,
		creationAllowed,
		fieldName
	}), $[32] = creationAllowed, $[33] = fieldName, $[34] = handleLinkDocument, $[35] = isAdding, $[36] = referenced, $[37] = type, $[38] = t10) : t10 = $[38];
	let t11;
	$[39] !== t10 || $[40] !== t8 || $[41] !== t9 ? (t11 = /* @__PURE__ */ jsxs(Card, {
		radius: 2,
		padding: 1,
		border: !0,
		tone: "default",
		children: [
			t8,
			t9,
			t10
		]
	}), $[39] = t10, $[40] = t8, $[41] = t9, $[42] = t11) : t11 = $[42];
	let t12;
	$[43] !== creationAllowed || $[44] !== fieldName || $[45] !== onLinkDocument || $[46] !== referenced.id || $[47] !== referenced.type || $[48] !== t || $[49] !== type ? (t12 = onLinkDocument ? /* @__PURE__ */ jsx(Button$1, {
		size: "large",
		disabled: !1,
		icon: AddIcon,
		mode: "ghost",
		onClick: handleAdd,
		text: t("incoming-references-input.add-reference-item")
	}) : /* @__PURE__ */ jsx(CreateNewIncomingReference, {
		type: type.type,
		referenceToId: referenced.id,
		referenceToType: referenced.type,
		creationAllowed,
		onCreateNewReference: handleCreateNewReference,
		fieldName
	}), $[43] = creationAllowed, $[44] = fieldName, $[45] = onLinkDocument, $[46] = referenced.id, $[47] = referenced.type, $[48] = t, $[49] = type, $[50] = t12) : t12 = $[50];
	let t13;
	return $[51] !== t11 || $[52] !== t12 || $[53] !== t7 ? (t13 = /* @__PURE__ */ jsxs(Flex, {
		gap: 2,
		marginBottom: 2,
		flexDirection: "column",
		children: [
			t7,
			t11,
			t12
		]
	}), $[51] = t11, $[52] = t12, $[53] = t7, $[54] = t13) : t13 = $[54], t13;
}
function _temp(p) {
	return !p;
}
function isCrossDatasetIncomingReference(type) {
	return !!type.dataset;
}
function IncomingReferencesList(t0) {
	let $ = c(26), { types, onLinkDocument, actions, filter, filterParams, name, creationAllowed } = t0, { documentId, documentType } = useDocumentPane(), { t } = useTranslation(structureLocaleNamespace);
	if (!types || types?.length === 0) {
		let t1;
		$[0] === t ? t1 = $[1] : (t1 = t("incoming-references-input.types-not-defined"), $[0] = t, $[1] = t1);
		let t2;
		return $[2] === t1 ? t2 = $[3] : (t2 = /* @__PURE__ */ jsx(Card, {
			border: !0,
			radius: 2,
			padding: 3,
			tone: "critical",
			children: /* @__PURE__ */ jsx(Flex, {
				alignItems: "center",
				justifyContent: "center",
				children: /* @__PURE__ */ jsx(Text, {
					size: 1,
					muted: !0,
					children: t1
				})
			})
		}), $[2] = t1, $[3] = t2), t2;
	}
	let t1;
	if ($[4] !== actions || $[5] !== creationAllowed || $[6] !== documentId || $[7] !== documentType || $[8] !== filter || $[9] !== filterParams || $[10] !== name || $[11] !== onLinkDocument || $[12] !== types) {
		let t2;
		$[14] !== actions || $[15] !== creationAllowed || $[16] !== documentId || $[17] !== documentType || $[18] !== filter || $[19] !== filterParams || $[20] !== name || $[21] !== onLinkDocument || $[22] !== types.length ? (t2 = (type) => isCrossDatasetIncomingReference(type) ? /* @__PURE__ */ jsx(CrossDatasetIncomingReferenceType, {
			type,
			referenced: {
				id: documentId,
				type: documentType
			},
			shouldRenderTitle: types.length > 1
		}, `${type.type}-${type.dataset || ""}`) : /* @__PURE__ */ jsx(IncomingReferencesType, {
			type,
			referenced: {
				id: documentId,
				type: documentType
			},
			onLinkDocument,
			actions,
			shouldRenderTitle: types.length > 1,
			fieldName: name,
			creationAllowed,
			filter,
			filterParams
		}, type.type), $[14] = actions, $[15] = creationAllowed, $[16] = documentId, $[17] = documentType, $[18] = filter, $[19] = filterParams, $[20] = name, $[21] = onLinkDocument, $[22] = types.length, $[23] = t2) : t2 = $[23], t1 = types.map(t2), $[4] = actions, $[5] = creationAllowed, $[6] = documentId, $[7] = documentType, $[8] = filter, $[9] = filterParams, $[10] = name, $[11] = onLinkDocument, $[12] = types, $[13] = t1;
	} else t1 = $[13];
	let t2;
	return $[24] === t1 ? t2 = $[25] : (t2 = /* @__PURE__ */ jsx(VStack, {
		gap: 3,
		children: t1
	}), $[24] = t1, $[25] = t2), t2;
}
/**
* @beta
*/
function IncomingReferencesDecoration(props) {
	let $ = c(21), { onLinkDocument, actions, filter, filterParams, name, creationAllowed: t0, types, title, description } = props, creationAllowed = t0 === void 0 || t0, t1;
	$[0] !== name || $[1] !== title ? (t1 = title || startCase(name), $[0] = name, $[1] = title, $[2] = t1) : t1 = $[2];
	let t2;
	$[3] === t1 ? t2 = $[4] : (t2 = /* @__PURE__ */ jsx(Flex, {
		alignItems: "center",
		paddingY: 1,
		children: /* @__PURE__ */ jsx(Text, {
			as: "label",
			weight: "medium",
			size: 1,
			children: t1
		})
	}), $[3] = t1, $[4] = t2);
	let t3;
	$[5] === description ? t3 = $[6] : (t3 = description && /* @__PURE__ */ jsx(Text, {
		muted: !0,
		size: 1,
		children: description
	}), $[5] = description, $[6] = t3);
	let t4;
	$[7] !== t2 || $[8] !== t3 ? (t4 = /* @__PURE__ */ jsx(Box$1, {
		paddingY: 2,
		children: /* @__PURE__ */ jsxs(VStack, {
			gap: 3,
			children: [t2, t3]
		})
	}), $[7] = t2, $[8] = t3, $[9] = t4) : t4 = $[9];
	let t5;
	$[10] !== actions || $[11] !== creationAllowed || $[12] !== filter || $[13] !== filterParams || $[14] !== name || $[15] !== onLinkDocument || $[16] !== types ? (t5 = /* @__PURE__ */ jsx(IncomingReferencesList, {
		name,
		types,
		onLinkDocument,
		actions,
		filter,
		filterParams,
		creationAllowed
	}), $[10] = actions, $[11] = creationAllowed, $[12] = filter, $[13] = filterParams, $[14] = name, $[15] = onLinkDocument, $[16] = types, $[17] = t5) : t5 = $[17];
	let t6;
	return $[18] !== t4 || $[19] !== t5 ? (t6 = /* @__PURE__ */ jsxs(VStack, {
		gap: 2,
		children: [t4, t5]
	}), $[18] = t4, $[19] = t5, $[20] = t6) : t6 = $[20], t6;
}
/**
* Helper function to define an incoming references decoration.
*
* example:
* ```ts
* defineType({
*   name: 'author',
*   type: 'document',
*   renderMembers: (members) => {
*    return [
*      ...members,
*      defineIncomingReferenceDecoration({
*        name: 'incomingReferences',
*        title: 'Incoming references',
*        types: [{type: 'author'}],
*      }),
*    ]
*   },
* })
* ```
*
* @beta
*/
function defineIncomingReferenceDecoration(options) {
	return {
		kind: "decoration",
		key: options.name,
		component: /* @__PURE__ */ jsx(IncomingReferencesDecoration, { ...options })
	};
}
/**
* Helper function to check if the document is being created from an incoming reference.
* It will be used in the initialValue callback to determine if the document is being created from an incoming reference.
*
* example:
* ```ts
* defineType({
*   name: 'book',
*   type: 'document',
*   fields: [...],
*   initialValue: (params) => {
*     // If the document is being created from an incoming reference, return the reference
*     // Otherwise, return undefined
*     return {
*       author: isIncomingReferenceCreation(params) ? params.reference : undefined,
*     }
*   },
* })
* ```
*
* @beta
*/
function isIncomingReferenceCreation(initialValue) {
	return typeof initialValue == "object" && !!initialValue && "__internal_isIncomingReferenceCreation" in initialValue;
}
export { ComponentBuilder, ComponentViewBuilder, ConfirmDeleteDialogContainer as ConfirmDeleteDialog, DEFAULT_INTENT_HANDLER, DocumentBuilder, DocumentInspectorHeader, DocumentListBuilder, DocumentListItemBuilder, PaneContainer as DocumentListPane, DocumentPane, DocumentPaneProviderWrapper as DocumentPaneProvider, DocumentTypeListBuilder, FormViewBuilder, GenericListBuilder, GenericViewBuilder, HELP_URL, InitialValueTemplateItemBuilder, ListBuilder, ListItemBuilder, MenuItemBuilder, MenuItemGroupBuilder, ORDER_BY_IDS_PARAM_FIELD, Pane, PaneContent, PaneLayout, PaneRouterContext, SerializeError, StructureToolProvider, component, createStructureBuilder, defaultInitialValueTemplateItems, defaultIntentChecker, defineIncomingReferenceDecoration, documentFromEditor, documentFromEditorWithInitialValue, form, getOrderingMenuItem, getOrderingMenuItemsForSchemaType, getTypeNamesFromFilter, isDocumentListItem, isIncomingReferenceCreation, maybeSerializeInitialValueTemplateItem, maybeSerializeMenuItem, maybeSerializeMenuItemGroup, maybeSerializeView, menuItemsFromInitialValueTemplateItems, shallowIntentChecker, structureLocaleNamespace, structureTool, useDocumentPane, useDocumentTitle, usePaneOptions, usePaneRouter, useStructureTool };

//# sourceMappingURL=structure.js.map